import { render, staticRenderFns } from "./shift-confirm-adjust.vue?vue&type=template&id=536551fd&scoped=true&"
import script from "./shift-confirm-adjust.vue?vue&type=script&lang=js&"
export * from "./shift-confirm-adjust.vue?vue&type=script&lang=js&"
import style0 from "./shift-confirm-adjust.vue?vue&type=style&index=0&id=536551fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536551fd",
  null
  
)

export default component.exports